import { z } from 'zod';
export const paymentScheduleStatus = z.enum(['active', 'inactive', 'draft', 'pending']);
export const expenseScheduleSource = z.enum(['manual', 'csv', 'contract']);
//# sourceMappingURL=paymentSchedule.js.map